import { Building2, Store, Utensils, Car, Shirt, Coffee, ShoppingBag, Wrench } from "lucide-react";

const SocialProofLogos = () => {
  const businessTypes = [
    { icon: Utensils, name: "Restaurants", color: "text-orange-600" },
    { icon: Store, name: "Retail", color: "text-blue-600" },
    { icon: Coffee, name: "Cafes", color: "text-amber-600" },
    { icon: Car, name: "Auto Services", color: "text-gray-600" },
    { icon: Shirt, name: "Boutiques", color: "text-purple-600" },
    { icon: ShoppingBag, name: "E-commerce", color: "text-green-600" },
    { icon: Wrench, name: "Services", color: "text-red-600" },
    { icon: Building2, name: "Professional", color: "text-indigo-600" },
  ];

  return (
    <section className="py-16 bg-muted/30" aria-labelledby="social-proof-heading">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <h2 id="social-proof-heading" className="text-lg font-semibold text-foreground uppercase tracking-wider mb-8">
            Trusted by 1,200+ Businesses Across South Florida
          </h2>
          
          {/* Business Type Icons */}
          <div className="max-w-5xl mx-auto bg-white rounded-xl p-8 shadow-lg border mb-8">
            <div className="grid grid-cols-4 md:grid-cols-8 gap-6">
              {businessTypes.map((business, index) => {
                const Icon = business.icon;
                return (
                  <div key={index} className="flex flex-col items-center group hover:scale-110 transition-transform duration-300">
                    <div className={`w-12 h-12 rounded-full bg-gray-50 border-2 border-gray-200 flex items-center justify-center group-hover:border-primary transition-colors duration-300`}>
                      <Icon className={`h-6 w-6 ${business.color} group-hover:text-primary transition-colors duration-300`} />
                    </div>
                    <span className="text-xs text-muted-foreground mt-2 font-medium">{business.name}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Trust Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto mb-8">
            <div className="bg-white rounded-lg p-6 shadow-md border">
              <div className="text-3xl font-bold text-primary mb-2">1,200+</div>
              <div className="text-sm text-muted-foreground">Active Merchants</div>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md border">
              <div className="text-3xl font-bold text-green-600 mb-2">$50M+</div>
              <div className="text-sm text-muted-foreground">Fees Saved</div>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md border">
              <div className="text-3xl font-bold text-blue-600 mb-2">4.9/5</div>
              <div className="text-sm text-muted-foreground">Customer Rating</div>
            </div>
          </div>
          
          <p className="text-base text-muted-foreground max-w-2xl mx-auto">
            From family restaurants to enterprise retailers, businesses choose Processing Bros for transparent pricing and expert support.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialProofLogos;